import Colors, { blend, withOpacity, } from '@polestar/component-warehouse-react/tokens/colors/Colors';
import Opacities from '@polestar/component-warehouse-react/tokens/opacities/Opacities';
import Spacings from '@polestar/component-warehouse-react/tokens/spacings/Spacings';
const AccordionTheme = {
    accordion: {
        light: {
            padding: {
                mobile: `${Spacings.large} 0`,
            },
            states: {
                enabled: {
                    color: Colors.black,
                    borderColor: Colors.black,
                },
                disabled: {
                    color: withOpacity(Colors.black, Opacities.low),
                    borderColor: blend(Colors.white, Colors.black, Opacities.xLow),
                },
                hover: {
                    color: Colors.black,
                    borderColor: Colors.black,
                },
                active: {
                    color: Colors.black,
                    borderColor: Colors.black,
                },
            },
        },
        dark: {
            states: {
                enabled: {
                    color: Colors.white,
                    borderColor: Colors.white,
                },
                disabled: {
                    color: withOpacity(Colors.white, Opacities.low),
                    borderColor: withOpacity(Colors.white, Opacities.xLow),
                },
                hover: {
                    color: Colors.white,
                    borderColor: Colors.white,
                },
                active: {
                    color: Colors.white,
                    borderColor: Colors.white,
                },
            },
        },
    },
};
export default AccordionTheme;
